<h2 mat-dialog-title> {{formTitle}}</h2>
<p-toast [style]="{marginTop: '80px'}">
</p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <div [formGroup]="form1">
    <div class="container-fluid">


      <div class="row wrap">
        <div class="col-lg-12 col-md-12">
          <div class="row wrap">
            <div class="col-lg-12">
              @if (formAlert) {
                <div class="w-100" style="padding:10px;">
                  <div class="w-100"
                    style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                    <p><b>{{formAlert}}</b></p>
                  </div>
                </div>
              }
            </div>
            <div class="col-lg-12">
              <div class="w-100">
                <h3>Overview</h3>
              </div>
            </div>
            <div class="col-lg-12">
              <mat-radio-group aria-label="Select an option" class="example-radio-group"
                formControlName="updateRateFor">
                <mat-radio-button value="RS">Modify Rate Seasons</mat-radio-button>
                <mat-radio-button value="RT">Modify Rates</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-lg-12">
              <mat-form-field class="w-100">
                <mat-label>Season Name</mat-label>
                <input matInput formControlName="name" readonly="{{formReadOnly}}" pTooltip="Public viewable">
                @for (validation of validationMessages.name; track validation) {
                  <mat-error>
                    @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field class="w-100">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startDatePicker" placeholder="Follow-Up Date"
                  formControlName="startDate"
                  pTooltip="Start of season - must NOT overlap with previous season's end date.">
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
                  @for (validation of validationMessages.startDate; track validation) {
                    <mat-error>
                      @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-6">
                <mat-form-field class="w-100">
                  <mat-label>End Date</mat-label> <input matInput [matDatepicker]="endDatePicker"
                  placeholder="Follow-Up Date" formControlName="endDate"
                  pTooltip="End of season - must NOT overlap with next season's start date.">
                  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
                  @for (validation of validationMessages.endDate; track validation) {
                    <mat-error>
                      @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                        <mat-error class="error-message"
                          >
                        {{validation.message}}</mat-error>
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-lg-2">
                <mat-label>Rack Rate</mat-label>
              </div>
              <div class="col-lg-3">
                <mat-form-field class="w-100">
                  <mat-label>By Value</mat-label>
                  <input matInput formControlName="listPriceAMT" readonly="{{formReadOnly}}"
                    pTooltip="Initial Rack Rate offered.">
                    @for (validation of validationMessages.listPriceAMT; track validation) {
                      <mat-error>
                        @if (form1.get('listPriceAMT').hasError(validation.type) && (form1.get('listPriceAMT').dirty || form1.get('listPriceAMT').touched)) {
                          <mat-error class="error-message"
                            >
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-lg-3">
                  <mat-label>By PCT: <b>{{listPriceAMTByPCT.value*100}}%</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAMTByPCT', 0.01)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="-1" max="1"
 step=".01"
 tooltipPosition="bottom">
  <input matSliderThumb #listPriceAMTByPCT formControlName="listPriceAMTByPCT">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAMTByPCT', 0.01)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  @if (form1.get('updateRateFor').value == 'RT') {
                    <mat-form-field class="w-100">
                      <mat-label>List Price AMT Exp Date</mat-label>
                      <input matInput [matDatepicker]="listPriceAMTExpDatePicker" formControlName="listPriceAMTExpDate">
                      <mat-datepicker-toggle matIconSuffix [for]="listPriceAMTExpDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #listPriceAMTExpDatePicker></mat-datepicker>
                      @for (validation of validationMessages.listPriceAMTExpDate; track validation) {
                        <mat-error>
                          @if (form1.get('listPriceAMTExpDate').hasError(validation.type) && (form1.get('listPriceAMTExpDate').dirty || form1.get('listPriceAMTExpDate').touched)) {
                            <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                      <a (click)="updateExpDate('listPriceAMTExpDate', 7)">7</a>&nbsp;
                      <a (click)="updateExpDate('listPriceAMTExpDate', 14)">14</a>&nbsp;
                      <a (click)="updateExpDate('listPriceAMTExpDate', 21)">21</a>&nbsp;
                      <a (click)="updateExpDate('listPriceAMTExpDate', 'N')">N</a>
                    </mat-form-field>
                  }
                </div>
                <div class="col-lg-2">
                  <mat-label>Min Nights Expected</mat-label>
                </div>
                <div class="col-lg-3">
                  <mat-label>Min Nights Expected: <b>{{minStayExpectedNTS.value}} nights</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('minStayExpectedNTS', 0.25)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="0" max="30"
									step=".25" pTooltip="Range: 0 to 365 as integer. Documents least number of nights of an acceptable booking. Bookings made for less nights will
								be assessd a penalty (see Mark-Ups below)" tooltipPosition="bottom">
  <input matSliderThumb #minStayExpectedNTS formControlName="minStayExpectedNTS">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('minStayExpectedNTS', 0.25)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-3">
                  <mat-label>By PCT: <b>{{minStayExpectedNTSByPCT.value*100}}%</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('minStayExpectedNTSByPCT', 0.01)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #minStayExpectedNTSByPCT formControlName="minStayExpectedNTSByPCT">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('minStayExpectedNTSByPCT', 0.01)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  @if (form1.get('updateRateFor').value == 'RT') {
                    <mat-form-field class="w-100">
                      <mat-label>Min Nights Expected Exp Date</mat-label>
                      <input matInput [matDatepicker]="minStayExpectedNTSExpDatePicker" formControlName="minStayExpectedNTSExpDate">
                      <mat-datepicker-toggle matIconSuffix [for]="minStayExpectedNTSExpDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #minStayExpectedNTSExpDatePicker></mat-datepicker>
                      @for (validation of validationMessages.minStayExpectedNTSExpDate; track validation) {
                        <mat-error>
                          @if (form1.get('minStayExpectedNTSExpDate').hasError(validation.type) && (form1.get('minStayExpectedNTSExpDate').dirty || form1.get('minStayExpectedNTSExpDate').touched)) {
                            <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                      <a (click)="updateExpDate('minStayExpectedNTSExpDate', 7)">7</a>&nbsp;
                      <a (click)="updateExpDate('minStayExpectedNTSExpDate', 14)">14</a>&nbsp;
                      <a (click)="updateExpDate('minStayExpectedNTSExpDate', 21)">21</a>&nbsp;
                      <a (click)="updateExpDate('minStayExpectedNTSExpDate', 'N')">N</a>
                    </mat-form-field>
                  }
                </div>
                <div class="col-lg-2">
                  <mat-label>Max Nights Expected</mat-label>
                </div>
                <div class="col-lg-3">
                  <mat-label>Max Nights Expected: <b>{{maxStayExpectedNTS.value}} nights</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxStayExpectedNTS', 0.25)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="0" max="30"
 step=".25"
 pTooltip="Range: 0 to 365 as integer. Documents number of nights of good solid bookings."
 tooltipPosition="bottom">
  <input matSliderThumb #maxStayExpectedNTS formControlName="maxStayExpectedNTS">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxStayExpectedNTS', 0.25)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-3">
                  <mat-label>By PCT: <b>{{maxStayExpectedNTSByPCT.value*100}}%</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxStayExpectedNTSByPCT', 0.01)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #maxStayExpectedNTSByPCT formControlName="maxStayExpectedNTSByPCT">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxStayExpectedNTSByPCT', 0.01)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  @if (form1.get('updateRateFor').value == 'RT') {
                    <mat-form-field class="w-100">
                      <mat-label>Max Nights Expected</mat-label>
                      <input matInput [matDatepicker]="maxStayExpectedNTSExpDatePicker" formControlName="maxStayExpectedNTSExpDate">
                      <mat-datepicker-toggle matIconSuffix [for]="maxStayExpectedNTSExpDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #maxStayExpectedNTSExpDatePicker></mat-datepicker>
                      @for (validation of validationMessages.maxStayExpectedNTSExpDate; track validation) {
                        <mat-error>
                          @if (form1.get('maxStayExpectedNTSExpDate').hasError(validation.type) && (form1.get('maxStayExpectedNTSExpDate').dirty || form1.get('maxStayExpectedNTSExpDate').touched)) {
                            <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                      <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 7)">7</a>&nbsp;
                      <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 14)">14</a>&nbsp;
                      <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 21)">21</a>&nbsp;
                      <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 'N')">N</a>
                    </mat-form-field>
                  }
                </div>
                <div class="col-lg-2">
                  <mat-label>Avg Nights Expected</mat-label>
                </div>
                <div class="col-lg-3">
                  <mat-label>Avg Nights Expected: <b>{{avgStayBySeasonNTS.value}} nights</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('avgStayBySeasonNTS', 0.25)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="0" max="30"
 step=".25"
 pTooltip="Range: 0 to 365 as integer. Documents number of nights of a reasonable booking."
 tooltipPosition="bottom">
  <input matSliderThumb #avgStayBySeasonNTS formControlName="avgStayBySeasonNTS">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('avgStayBySeasonNTS', 0.25)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-3">
                  <mat-label>By PCT: <b>{{avgStayBySeasonNTSByPCT.value*100}}%</b></mat-label>
                  <div>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('avgStayBySeasonNTSByPCT', 0.01)">
                      <i class="pi pi-minus"></i>
                    </button>
                    <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #avgStayBySeasonNTSByPCT formControlName="avgStayBySeasonNTSByPCT">
</mat-slider>
                    <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('avgStayBySeasonNTSByPCT', 0.01)">
                      <i class="pi pi-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  @if (form1.get('updateRateFor').value == 'RT') {
                    <mat-form-field class="w-100">
                      <mat-label>Avg Nights Expected Exp Date</mat-label>
                      <input matInput [matDatepicker]="avgStayBySeasonNTSExpDatePicker" formControlName="avgStayBySeasonNTSExpDate">
                      <mat-datepicker-toggle matIconSuffix [for]="avgStayBySeasonNTSExpDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #avgStayBySeasonNTSExpDatePicker></mat-datepicker>
                      @for (validation of validationMessages.avgStayBySeasonNTSExpDate; track validation) {
                        <mat-error>
                          @if (form1.get('avgStayBySeasonNTSExpDate').hasError(validation.type) && (form1.get('avgStayBySeasonNTSExpDate').dirty || form1.get('avgStayBySeasonNTSExpDate').touched)) {
                            <mat-error class="error-message">
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                      <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 7)">7</a>&nbsp;
                      <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 14)">14</a>&nbsp;
                      <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 21)">21</a>&nbsp;
                      <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 'N')">N</a>
                    </mat-form-field>
                  }
                </div>
                <div class="col-lg-2">
                  <mat-label>Min Nightly Rate $ (Manager)</mat-label>
                </div>
                <div class="col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>By Value</mat-label>
                    <input matInput formControlName="floorRateManagerAMT" readonly="{{formReadOnly}}"
                      pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Manager.  Will be overridden by Min Nightly Rate $ set by Owner if exists.">
                      @for (validation of validationMessages.floorRateManagerAMT; track validation) {
                        <mat-error>
                          @if (form1.get('floorRateManagerAMT').hasError(validation.type) && (form1.get('floorRateManagerAMT').dirty || form1.get('floorRateManagerAMT').touched)) {
                            <mat-error class="error-message"
                              >
                              {{validation.message}}
                            </mat-error>
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-lg-3">
                    <mat-label>By PCT: <b>{{floorRateManagerAMTByPCT.value*100}}%</b></mat-label>
                    <div>
                      <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('floorRateManagerAMTByPCT', 0.01)">
                        <i class="pi pi-minus"></i>
                      </button>
                      <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #floorRateManagerAMTByPCT formControlName="floorRateManagerAMTByPCT">
</mat-slider>
                      <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('floorRateManagerAMTByPCT', 0.01)">
                        <i class="pi pi-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    @if (form1.get('updateRateFor').value == 'RT') {
                      <mat-form-field class="w-100">
                        <mat-label>Min Nightly Rate Exp Date</mat-label>
                        <input matInput [matDatepicker]="floorRateManagerAMTExpDatePicker" formControlName="floorRateManagerAMTExpDate">
                        <mat-datepicker-toggle matIconSuffix [for]="floorRateManagerAMTExpDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #floorRateManagerAMTExpDatePicker></mat-datepicker>
                        @for (validation of validationMessages.floorRateManagerAMTExpDate; track validation) {
                          <mat-error>
                            @if (form1.get('floorRateManagerAMTExpDate').hasError(validation.type) && (form1.get('floorRateManagerAMTExpDate').dirty || form1.get('floorRateManagerAMTExpDate').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                        <a (click)="updateExpDate('floorRateManagerAMTExpDate', 7)">7</a>&nbsp;
                        <a (click)="updateExpDate('floorRateManagerAMTExpDate', 14)">14</a>&nbsp;
                        <a (click)="updateExpDate('floorRateManagerAMTExpDate', 21)">21</a>&nbsp;
                        <a (click)="updateExpDate('floorRateManagerAMTExpDate', 'N')">N</a>
                      </mat-form-field>
                    }
                  </div>
                  <div class="col-lg-2">
                    <mat-label>Min Nightly Rate $ (Owner)</mat-label>
                  </div>
                  <div class="col-lg-3">
                    <mat-form-field class="w-100">
                      <mat-label>By Value</mat-label>
                      <input matInput formControlName="floorRateOwnerAMT" readonly="{{formReadOnly}}"
                        pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Owner.  Overrides Min Nightly Rate $ set by Manager.">
                        @for (validation of validationMessages.floorRateOwnerAMT; track validation) {
                          <mat-error>
                            @if (form1.get('floorRateOwnerAMT').hasError(validation.type) && (form1.get('floorRateOwnerAMT').dirty || form1.get('floorRateOwnerAMT').touched)) {
                              <mat-error class="error-message"
                                >
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                      <mat-label>By PCT: <b>{{floorRateOwnerAMTByPCT.value*100}}%</b></mat-label>
                      <div>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('floorRateOwnerAMTByPCT', 0.01)">
                          <i class="pi pi-minus"></i>
                        </button>
                        <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #floorRateOwnerAMTByPCT formControlName="floorRateOwnerAMTByPCT">
</mat-slider>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('floorRateOwnerAMTByPCT', 0.01)">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      @if (form1.get('updateRateFor').value == 'RT') {
                        <mat-form-field class="w-100">
                          <mat-label>Min Nightly Rate Exp Date</mat-label>
                          <input matInput [matDatepicker]="floorRateOwnerAMTExpDatePicker" formControlName="floorRateOwnerAMTExpDate">
                          <mat-datepicker-toggle matIconSuffix [for]="floorRateOwnerAMTExpDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #floorRateOwnerAMTExpDatePicker></mat-datepicker>
                          @for (validation of validationMessages.floorRateOwnerAMTExpDate; track validation) {
                            <mat-error>
                              @if (form1.get('floorRateOwnerAMTExpDate').hasError(validation.type) && (form1.get('floorRateOwnerAMTExpDate').dirty || form1.get('floorRateOwnerAMTExpDate').touched)) {
                                <mat-error class="error-message">
                                {{validation.message}}</mat-error>
                              }
                            </mat-error>
                          }
                          <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 7)">7</a>&nbsp;
                          <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 14)">14</a>&nbsp;
                          <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 21)">21</a>&nbsp;
                          <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 'N')">N</a>
                        </mat-form-field>
                      }
                    </div>
                    <div class="col-lg-2">
                      <mat-label>Season Occupancy</mat-label>
                    </div>
                    <div class="col-lg-3">
                      <mat-label>Season Occupancy : <b>{{expectedOccupancyPCT.value*100}}%</b></mat-label>
                      <div>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('expectedOccupancyPCT', 0.01)">
                          <i class="pi pi-minus"></i>
                        </button>
                        <mat-slider class="flex-1" min="0" max="1" step=".01"
 pTooltip="Range: 0 to 100 as decimal. Estimates the occupancy for each season for calculations to the rack rate"
 tooltipPosition="bottom">
  <input matSliderThumb #expectedOccupancyPCT formControlName="expectedOccupancyPCT">
</mat-slider>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('expectedOccupancyPCT', 0.01)">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <mat-label>By PCT: <b>{{expectedOccupancyPCTByPCT.value*100}}%</b></mat-label>
                      <div>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('expectedOccupancyPCTByPCT', 0.01)">
                          <i class="pi pi-minus"></i>
                        </button>
                        <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #expectedOccupancyPCTByPCT formControlName="expectedOccupancyPCTByPCT">
</mat-slider>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('expectedOccupancyPCTByPCT', 0.01)">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      @if (form1.get('updateRateFor').value == 'RT') {
                        <mat-form-field class="w-100">
                          <mat-label>Season Occupancy Exp Date</mat-label>
                          <input matInput [matDatepicker]="expectedOccupancyPCTExpDatePicker" formControlName="expectedOccupancyPCTExpDate">
                          <mat-datepicker-toggle matIconSuffix [for]="expectedOccupancyPCTExpDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #expectedOccupancyPCTExpDatePicker></mat-datepicker>
                          @for (validation of validationMessages.expectedOccupancyPCTExpDate; track validation) {
                            <mat-error>
                              @if (form1.get('expectedOccupancyPCTExpDate').hasError(validation.type) && (form1.get('expectedOccupancyPCTExpDate').dirty || form1.get('expectedOccupancyPCTExpDate').touched)) {
                                <mat-error class="error-message">
                                {{validation.message}}</mat-error>
                              }
                            </mat-error>
                          }
                          <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 7)">7</a>&nbsp;
                          <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 14)">14</a>&nbsp;
                          <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 21)">21</a>&nbsp;
                          <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 'N')">N</a>
                        </mat-form-field>
                      }
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 flex-column">
                  <div style="flex: 0 0 calc(100% - 30px)">
                    <h3>Settings</h3>
                  </div>


                  <!-- <div style="flex: 0 0 calc(100% - 30px)">
                  <mat-label>Min Nights Expected: <b>{{minStayExpectedNTS.value}} nights</b></mat-label>
                  <div>
                    <mat-slider class="flex-1" min="0" max="30"
								step=".25" pTooltip="Range: 0 to 365 as integer. Documents least number of nights of an acceptable booking. Bookings made for less nights will
							be assessd a penalty (see Mark-Ups below)" tooltipPosition="bottom">
  <input matSliderThumb #minStayExpectedNTS formControlName="minStayExpectedNTS">
</mat-slider>
                  </div>
                </div>

                <div style="flex: 0 0 calc(100% - 30px)">
                  <mat-label>Max Nights Expected: <b>{{maxStayExpectedNTS.value}} nights</b></mat-label>
                  <div>
                    <mat-slider class="flex-1" min="0" max="30"
 step=".25"
 pTooltip="Range: 0 to 365 as integer. Documents number of nights of good solid bookings."
 tooltipPosition="bottom">
  <input matSliderThumb #maxStayExpectedNTS formControlName="maxStayExpectedNTS">
</mat-slider>
                  </div>
                </div>

                <div style="flex: 0 0 calc(100% - 30px)">
                  <mat-label>Avg Nights Expected: <b>{{avgStayBySeasonNTS.value}} nights</b></mat-label>
                  <div>
                    <mat-slider class="flex-1" min="0" max="30"
 step=".25"
 pTooltip="Range: 0 to 365 as integer. Documents number of nights of a reasonable booking."
 tooltipPosition="bottom">
  <input matSliderThumb #avgStayBySeasonNTS formControlName="avgStayBySeasonNTS">
</mat-slider>
                  </div>
                </div>

                <mat-form-field style="flex: 0 0 calc(50% - 30px)">
                  <mat-label>Min Nightly Rate $ (Manager)</mat-label>
                  <input matInput formControlName="floorRateManagerAMT" readonly="{{formReadOnly}}"
                    pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Manager.  Will be overridden by Min Nightly Rate $ set by Owner if exists.">
                    <mat-error *ngFor="let validation of validationMessages.floorRateManagerAMT">
                      <mat-error class="error-message"
                        *ngIf="form1.get('floorRateManagerAMT').hasError(validation.type) && (form1.get('floorRateManagerAMT').dirty || form1.get('floorRateManagerAMT').touched)">
                        {{validation.message}}
                      </mat-error>
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field style="flex: 0 0 calc(50% - 30px)">
                    <mat-label>Min Nightly Rate $ (Owner)</mat-label>
                    <input matInput formControlName="floorRateOwnerAMT" readonly="{{formReadOnly}}"
                      pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Owner.  Overrides Min Nightly Rate $ set by Manager.">
                      <mat-error *ngFor="let validation of validationMessages.floorRateOwnerAMT">
                        <mat-error class="error-message"
                          *ngIf="form1.get('floorRateOwnerAMT').hasError(validation.type) && (form1.get('floorRateOwnerAMT').dirty || form1.get('floorRateOwnerAMT').touched)">
                          {{validation.message}}
                        </mat-error>
                      </mat-error>
                    </mat-form-field> -->

                    <mat-form-field style="flex: 0 0 calc(50% - 30px)">
                      <mat-label>Season Demand</mat-label>
                      <mat-select [(value)]="form1.value.category" formControlName="category"
                        pTooltip="Range: Low to High (1-5). Documents perceived demand for accomodations.">
                        @for (stat of seasonCategories; track stat) {
                          <mat-option [value]="stat.value"> {{stat.name}}
                          </mat-option>
                        }
                      </mat-select>
                      @for (validation of validationMessages.category; track validation) {
                        <mat-error>
                          @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                            <mat-error class="error-message"
                              >
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                    </mat-form-field>

                    <mat-form-field style="flex: 0 0 calc(50% - 30px)">
                      <mat-label>Rate Bucket Type</mat-label>
                      <mat-select [(value)]="form1.value.type" formControlName="type"
                        pTooltip="Auto: Rack Rate adjusted by system or by bulk updates.  Manual:  Rate static, will not change by system or bulk updates.">
                        @for (stat of rateBucketTypes; track stat) {
                          <mat-option [value]="stat.value"> {{stat.name}}
                          </mat-option>
                        }
                      </mat-select>
                      @for (validation of validationMessages.type; track validation) {
                        <mat-error>
                          @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                            <mat-error class="error-message"
                              >
                            {{validation.message}}</mat-error>
                          }
                        </mat-error>
                      }
                    </mat-form-field>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12" style="padding-top:50px;">
                    <mat-divider></mat-divider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="row">
                      <div class="col-lg-12">
                        <h3>Discounts</h3>
                      </div>

                      <mat-form-field class="col-lg-12 col-md-12">
                        <mat-label>Algorithm</mat-label>
                        <mat-select [(value)]="form1.value.discountAlorithm" formControlName="discountAlorithm"
                          pTooltip="Selects the algorithm applied to calculate discounts.">
                          @for (stat of discountAlorithms; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}}
                            </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.discountAlorithm; track validation) {
                          <mat-error>
                            @if (form1.get('discountAlorithm').hasError(validation.type) && (form1.get('discountAlorithm').dirty || form1.get('discountAlorithm').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <div class="col-lg-2">
                        <mat-label>Rack Rate Discount $</mat-label>
                      </div>
                      <div class="col-lg-2">
                        <mat-form-field class="w-100">
                          <input matInput formControlName="listPriceAdjustAMT" readonly="{{formReadOnly}}"
                            pTooltip="Overrides Rack Rate AND any discount .">
                            @for (validation of validationMessages.listPriceAdjustAMT; track validation) {
                              <mat-error>
                                @if (form1.get('listPriceAdjustAMT').hasError(validation.type) && (form1.get('listPriceAdjustAMT').dirty || form1.get('listPriceAdjustAMT').touched)) {
                                  <mat-error class="error-message"
                                    >
                                    {{validation.message}}
                                  </mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{listPriceAdjustAMTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAdjustAMTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #listPriceAdjustAMTByPCT formControlName="listPriceAdjustAMTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAdjustAMTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Rack Rate Discount Exp Date</mat-label>
                              <input matInput [matDatepicker]="listPriceAdjustAMTExpDatePicker" formControlName="listPriceAdjustAMTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="listPriceAdjustAMTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #listPriceAdjustAMTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.listPriceAdjustAMTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('listPriceAdjustAMTExpDate').hasError(validation.type) && (form1.get('listPriceAdjustAMTExpDate').dirty || form1.get('listPriceAdjustAMTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Rack Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Rack Rate Adjustment: <b>{{listPriceAdjustPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAdjustPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #listPriceAdjustPCT formControlName="listPriceAdjustPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAdjustPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{listPriceAdjustPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAdjustPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #listPriceAdjustPCTByPCT formControlName="listPriceAdjustPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAdjustPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Rack Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="listPriceAdjustPCTExpDatePicker" formControlName="listPriceAdjustPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="listPriceAdjustPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #listPriceAdjustPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.listPriceAdjustPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('listPriceAdjustPCTExpDate').hasError(validation.type) && (form1.get('listPriceAdjustPCTExpDate').dirty || form1.get('listPriceAdjustPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Monday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Monday Rate Adjustment: <b>{{mondayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('mondayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #mondayAdjPCT formControlName="mondayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('mondayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{mondayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('mondayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #mondayAdjPCTByPCT formControlName="mondayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('mondayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Monday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="mondayAdjPCTExpDatePicker" formControlName="mondayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="mondayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #mondayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.mondayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('mondayAdjPCTExpDate').hasError(validation.type) && (form1.get('mondayAdjPCTExpDate').dirty || form1.get('mondayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('mondayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('mondayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('mondayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('mondayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Tuesday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Tuesday Rate Adjustment: <b>{{tuesdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('tuesdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #tuesdayAdjPCT formControlName="tuesdayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('tuesdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{tuesdayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('tuesdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #tuesdayAdjPCTByPCT formControlName="tuesdayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('tuesdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Tuesday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="tuesdayAdjPCTExpDatePicker" formControlName="tuesdayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="tuesdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #tuesdayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.tuesdayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('tuesdayAdjPCTExpDate').hasError(validation.type) && (form1.get('tuesdayAdjPCTExpDate').dirty || form1.get('tuesdayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Wednesday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Wednesday Rate Adjustment: <b>{{wednesdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('wednesdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #wednesdayAdjPCT formControlName="wednesdayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('wednesdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{wednesdayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('wednesdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #wednesdayAdjPCTByPCT formControlName="wednesdayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('wednesdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Wednesday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="wednesdayAdjPCTExpDatePicker" formControlName="wednesdayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="wednesdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #wednesdayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.wednesdayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('wednesdayAdjPCTExpDate').hasError(validation.type) && (form1.get('wednesdayAdjPCTExpDate').dirty || form1.get('wednesdayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Thursday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Thursday Rate Adjustment: <b>{{thursdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('thursdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #thursdayAdjPCT formControlName="thursdayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('thursdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{thursdayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('thursdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #thursdayAdjPCTByPCT formControlName="thursdayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('thursdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Thursday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="thursdayAdjPCTExpDatePicker" formControlName="thursdayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="thursdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #thursdayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.thursdayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('thursdayAdjPCTExpDate').hasError(validation.type) && (form1.get('thursdayAdjPCTExpDate').dirty || form1.get('thursdayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Friday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Friday Rate Adjustment: <b>{{fridayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('fridayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #fridayAdjPCT formControlName="fridayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('fridayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{fridayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('fridayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #fridayAdjPCTByPCT formControlName="fridayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('fridayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Friday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="fridayAdjPCTExpDatePicker" formControlName="fridayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="fridayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #fridayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.fridayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('fridayAdjPCTExpDate').hasError(validation.type) && (form1.get('fridayAdjPCTExpDate').dirty || form1.get('fridayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('fridayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('fridayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('fridayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('fridayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Saturday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Saturday Rate Adjustment: <b>{{saturdayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('saturdayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #saturdayAdjPCT formControlName="saturdayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('saturdayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{saturdayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('saturdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #saturdayAdjPCTByPCT formControlName="saturdayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('saturdayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Saturday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="saturdayAdjPCTExpDatePicker" formControlName="saturdayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="saturdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #saturdayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.saturdayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('saturdayAdjPCTExpDate').hasError(validation.type) && (form1.get('saturdayAdjPCTExpDate').dirty || form1.get('saturdayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Sunday Rate Adjustment</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Sunday Rate Adjustment: <b>{{sundayAdjPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('sundayAdjPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #sundayAdjPCT formControlName="sundayAdjPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('sundayAdjPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{sundayAdjPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('sundayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #sundayAdjPCTByPCT formControlName="sundayAdjPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('sundayAdjPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Sunday Rate Adjustment Exp Date</mat-label>
                              <input matInput [matDatepicker]="sundayAdjPCTExpDatePicker" formControlName="sundayAdjPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="sundayAdjPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #sundayAdjPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.sundayAdjPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('sundayAdjPCTExpDate').hasError(validation.type) && (form1.get('sundayAdjPCTExpDate').dirty || form1.get('sundayAdjPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('sundayAdjPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('sundayAdjPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('sundayAdjPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('sundayAdjPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Days to Start Discounting</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Days to Start Discounting: <b>{{discountLookForwardDays.value}} days</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardDays', 1)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="0"
 max="365" step="1"
 pTooltip="Range: 0 to 365 as integer. Determines how many days in advance of each available occupancy period to apply discounting algorithms. A setting of 0 will apply NO discounts regardless of discount settings."
 tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardDays formControlName="discountLookForwardDays">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardDays', 1)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{discountLookForwardDaysByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardDaysByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #discountLookForwardDaysByPCT formControlName="discountLookForwardDaysByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardDaysByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Days to Start Discounting Exp Date</mat-label>
                              <input matInput [matDatepicker]="discountLookForwardDaysExpDatePicker" formControlName="discountLookForwardDaysExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardDaysExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #discountLookForwardDaysExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.discountLookForwardDaysExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('discountLookForwardDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardDaysExpDate').dirty || form1.get('discountLookForwardDaysExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('discountLookForwardDaysExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardDaysExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardDaysExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardDaysExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Max Discount</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Max Discount: <b>{{maxDiscountPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxDiscountPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1"
 step=".01"
 pTooltip="Range: 0 to 100 as decimal. Determines the maximum discount to apply to the rack rate, but will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #maxDiscountPCT formControlName="maxDiscountPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxDiscountPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{maxDiscountPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxDiscountPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #maxDiscountPCTByPCT formControlName="maxDiscountPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxDiscountPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Max Discount Exp Date</mat-label>
                              <input matInput [matDatepicker]="maxDiscountPCTExpDatePicker" formControlName="maxDiscountPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="maxDiscountPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #maxDiscountPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.maxDiscountPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('maxDiscountPCTExpDate').hasError(validation.type) && (form1.get('maxDiscountPCTExpDate').dirty || form1.get('maxDiscountPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('maxDiscountPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('maxDiscountPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('maxDiscountPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('maxDiscountPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier:
                          <b>{{connectingFrontOrBackMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontOrBackMultiplierPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount for connecting either the front OR the back of an existing reservation,
							positive value will decrease the discount for connecting either the front OR the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
  <input matSliderThumb #connectingFrontOrBackMultiplierPCT formControlName="connectingFrontOrBackMultiplierPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontOrBackMultiplierPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{connectingFrontOrBackMultiplierPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontOrBackMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #connectingFrontOrBackMultiplierPCTByPCT formControlName="connectingFrontOrBackMultiplierPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontOrBackMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier Exp Date</mat-label>
                              <input matInput [matDatepicker]="connectingFrontOrBackMultiplierPCTExpDatePicker" formControlName="connectingFrontOrBackMultiplierPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="connectingFrontOrBackMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #connectingFrontOrBackMultiplierPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.connectingFrontOrBackMultiplierPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('connectingFrontOrBackMultiplierPCTExpDate').hasError(validation.type) && (form1.get('connectingFrontOrBackMultiplierPCTExpDate').dirty || form1.get('connectingFrontOrBackMultiplierPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Connecting Front <u>And</u> Back Discount Multiplier</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Connecting Front <u>And</u> Back Discount Multiplier:
                          <b>{{connectingFrontAndBackMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontAndBackMultiplierPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount for connecting both the front AND the back of an existing reservation,
							positive value will decrease the discount for connecting both the front AND the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
  <input matSliderThumb #connectingFrontAndBackMultiplierPCT formControlName="connectingFrontAndBackMultiplierPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontAndBackMultiplierPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{connectingFrontAndBackMultiplierPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontAndBackMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #connectingFrontAndBackMultiplierPCTByPCT formControlName="connectingFrontAndBackMultiplierPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontAndBackMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Connecting Front <u>And</u> Back Discount Multiplier Exp Date</mat-label>
                              <input matInput [matDatepicker]="connectingFrontAndBackMultiplierPCTExpDatePicker" formControlName="connectingFrontAndBackMultiplierPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="connectingFrontAndBackMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #connectingFrontAndBackMultiplierPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.connectingFrontAndBackMultiplierPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('connectingFrontAndBackMultiplierPCTExpDate').hasError(validation.type) && (form1.get('connectingFrontAndBackMultiplierPCTExpDate').dirty || form1.get('connectingFrontAndBackMultiplierPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Short Gap Adjuster</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Short Gap Adjuster: <b>{{lengthOfStayDiscountFactorOffset.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('lengthOfStayDiscountFactorOffset', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
									 min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount, positive will decrease discount.
									Kicks in if numberOfNights available is less than minNightsExpected. EXAMPLE: There is a two night gap and our minNightsExpected is 3.
									A negative Short Gap Adjuster will reduce the price of the 2 night gap by xx% to incentivize a booking."
 tooltipPosition="bottom">
  <input matSliderThumb #lengthOfStayDiscountFactorOffset formControlName="lengthOfStayDiscountFactorOffset">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('lengthOfStayDiscountFactorOffset', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{lengthOfStayDiscountFactorOffsetByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('lengthOfStayDiscountFactorOffsetByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #lengthOfStayDiscountFactorOffsetByPCT formControlName="lengthOfStayDiscountFactorOffsetByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('lengthOfStayDiscountFactorOffsetByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Short Gap Adjuster Exp Date</mat-label>
                              <input matInput [matDatepicker]="lengthOfStayDiscountFactorOffsetExpDatePicker" formControlName="lengthOfStayDiscountFactorOffsetExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="lengthOfStayDiscountFactorOffsetExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #lengthOfStayDiscountFactorOffsetExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.lengthOfStayDiscountFactorOffsetExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('lengthOfStayDiscountFactorOffsetExpDate').hasError(validation.type) && (form1.get('lengthOfStayDiscountFactorOffsetExpDate').dirty || form1.get('lengthOfStayDiscountFactorOffsetExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <!-- <mat-form-field class="col-lg-6 col-md-6">
                        <mat-label>Rack Rate Discount $ </mat-label>
                        <input matInput formControlName="listPriceAdjustAMT" readonly="{{formReadOnly}}"
                          pTooltip="Overrides Rack Rate AND any discount .">
                          <mat-error *ngFor="let validation of validationMessages.listPriceAdjustAMT">
                            <mat-error class="error-message"
                              *ngIf="form1.get('listPriceAdjustAMT').hasError(validation.type) && (form1.get('listPriceAdjustAMT').dirty || form1.get('listPriceAdjustAMT').touched)">
                              {{validation.message}}
                            </mat-error>
                          </mat-error>
                        </mat-form-field>

                        <div class="col-lg-12">
                          <mat-label>Rack Rate Adjustment: <b>{{listPriceAdjustPCT.value*100}}%</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
 pTooltip="Range: -1 to 1 as decimal. Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly. Will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #listPriceAdjustPCT formControlName="listPriceAdjustPCT">
</mat-slider>
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <mat-label>Days to Start Discounting: <b>{{discountLookForwardDays.value}} days</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" min="0"
 max="365" step="1"
 pTooltip="Range: 0 to 365 as integer. Determines how many days in advance of each available occupancy period to apply discounting algorithms. A setting of 0 will apply NO discounts regardless of discount settings."
 tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardDays formControlName="discountLookForwardDays">
</mat-slider>
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <mat-label>Max Discount: <b>{{maxDiscountPCT.value*100}}%</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" min="-1" max="1"
 step=".01"
 pTooltip="Range: 0 to 100 as decimal. Determines the maximum discount to apply to the rack rate, but will not go lower than the the Min Nightly Rate $ setting below."
 tooltipPosition="bottom">
  <input matSliderThumb #maxDiscountPCT formControlName="maxDiscountPCT">
</mat-slider>
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier:
                          <b>{{connectingFrontOrBackMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount for connecting either the front OR the back of an existing reservation,
							positive value will decrease the discount for connecting either the front OR the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
  <input matSliderThumb #connectingFrontOrBackMultiplierPCT formControlName="connectingFrontOrBackMultiplierPCT">
</mat-slider>
                          </div>
                        </div>


                        <div class="col-lg-12">
                          <mat-label>Connecting Front <u>And</u> Back Discount Multiplier:
                          <b>{{connectingFrontAndBackMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" 
 min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount for connecting both the front AND the back of an existing reservation,
							positive value will decrease the discount for connecting both the front AND the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
  <input matSliderThumb #connectingFrontAndBackMultiplierPCT formControlName="connectingFrontAndBackMultiplierPCT">
</mat-slider>
                          </div>
                        </div>



                        <div class="col-lg-12">
                          <mat-label>Short Gap Adjuster: <b>{{lengthOfStayDiscountFactorOffset.value*100}}%</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" 
									 min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount, positive will decrease discount.
									Kicks in if numberOfNights available is less than minNightsExpected. EXAMPLE: There is a two night gap and our minNightsExpected is 3.
									A negative Short Gap Adjuster will reduce the price of the 2 night gap by xx% to incentivize a booking."
 tooltipPosition="bottom">
  <input matSliderThumb #lengthOfStayDiscountFactorOffset formControlName="lengthOfStayDiscountFactorOffset">
</mat-slider>
                          </div>
                        </div> -->
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12">
                      <div class="row">
                        <div class="col-lg-12">
                          <h3>Mark-Ups</h3>
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Short Gap Occupancy Target</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Short Gap Occupancy Target: <b>{{shortTermGapMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMultiplierPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="0"
 max="1" step=".01"
									pTooltip="Range: 0-1 as decimal. Applies a penalty if the number of nights available is less than the minNightsExpected. EXAMPLE: minNightsExpected is 4, but only 3 nights are available in gap. A setting of 0% means there will be no penalty to rate if they rent 1 out
							of the 3 nights. A setting of 100% means there would be a 2 night penalty to rate if they rented 1 out of 3 nights"
 tooltipPosition="bottom">
  <input matSliderThumb #shortTermGapMultiplierPCT formControlName="shortTermGapMultiplierPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMultiplierPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{shortTermGapMultiplierPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #shortTermGapMultiplierPCTByPCT formControlName="shortTermGapMultiplierPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Short Gap Occupancy Target Exp Date</mat-label>
                              <input matInput [matDatepicker]="shortTermGapMultiplierPCTExpDatePicker" formControlName="shortTermGapMultiplierPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="shortTermGapMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #shortTermGapMultiplierPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.shortTermGapMultiplierPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('shortTermGapMultiplierPCTExpDate').hasError(validation.type) && (form1.get('shortTermGapMultiplierPCTExpDate').dirty || form1.get('shortTermGapMultiplierPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Short Gap Penalty</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Short Gap Penalty: <b>{{shortTermGapPenaltyPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapPenaltyPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
									min="0" max="1" step=".01" pTooltip="Range: 0-1 as decimal. Determine how much of the Short Term Gap Occupancy Target penalty to apply. EXAMPLE: A setting of 0% will apply NONE of the Short Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Short Term Gap Occupancy Target penalty.
							If 2.8 nights desired but only 2 nights rented, a setting of xx% will apply only to the .8 night penalty."
 tooltipPosition="bottom">
  <input matSliderThumb #shortTermGapPenaltyPCT formControlName="shortTermGapPenaltyPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapPenaltyPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{shortTermGapPenaltyPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapPenaltyPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #shortTermGapPenaltyPCTByPCT formControlName="shortTermGapPenaltyPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapPenaltyPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Short Gap Penalty Exp Date</mat-label>
                              <input matInput [matDatepicker]="shortTermGapPenaltyPCTExpDatePicker" formControlName="shortTermGapPenaltyPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="shortTermGapPenaltyPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #shortTermGapPenaltyPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.shortTermGapPenaltyPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('shortTermGapPenaltyPCTExpDate').hasError(validation.type) && (form1.get('shortTermGapPenaltyPCTExpDate').dirty || form1.get('shortTermGapPenaltyPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Short Gap Min Required Nights of Revenue</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Short Gap Min Required Nights of Revenue: <b>{{shortTermGapMinNumNightsRevNTS.value}}
                          nights</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMinNumNightsRevNTS', 0.25)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="0" max="10" step=".25"
 pTooltip="Range: 0-10 as integer. Determines how many nights of revenue minimum to charge a guest if the avaialble nights is less than the minExpected nights. EXAMPLE: Assume a 1 nights gap between two Christmas bookings. A setting of 3 nights will allow the guest to book just the 1 night, but charge them for 3 even though it is a perfect back to back."
 tooltipPosition="bottom">
  <input matSliderThumb #shortTermGapMinNumNightsRevNTS formControlName="shortTermGapMinNumNightsRevNTS">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMinNumNightsRevNTS', 0.25)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{shortTermGapMinNumNightsRevNTSPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMinNumNightsRevNTSPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #shortTermGapMinNumNightsRevNTSPCT formControlName="shortTermGapMinNumNightsRevNTSPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMinNumNightsRevNTSPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Short Gap Min Required Nights of Revenue Exp Date</mat-label>
                              <input matInput [matDatepicker]="shortTermGapMinNumNightsRevNTSExpDatePicker" formControlName="shortTermGapMinNumNightsRevNTSExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="shortTermGapMinNumNightsRevNTSExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #shortTermGapMinNumNightsRevNTSExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.shortTermGapMinNumNightsRevNTSExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('shortTermGapMinNumNightsRevNTSExpDate').hasError(validation.type) && (form1.get('shortTermGapMinNumNightsRevNTSExpDate').dirty || form1.get('shortTermGapMinNumNightsRevNTSExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Long Gap Occupancy Target</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Long Gap Occupancy Target: <b>{{longTermGapMultiplierPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapMultiplierPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="0"
 max="1" step=".01"
									pTooltip="Range: 0-1 as decimal. EXAMPLE: A setting of 0% means there will be no penalty to rate if they rent 6 out
							of 12 nights with 3 night gaps on either side. A setting of 100% means there would be a 6 night penalty to rate if they rented 6 out of 12 nights with 3 night gaps on either side"
 tooltipPosition="bottom">
  <input matSliderThumb #longTermGapMultiplierPCT formControlName="longTermGapMultiplierPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapMultiplierPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{longTermGapMultiplierPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #longTermGapMultiplierPCTByPCT formControlName="longTermGapMultiplierPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapMultiplierPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Long Gap Occupancy Target Exp Date</mat-label>
                              <input matInput [matDatepicker]="longTermGapMultiplierPCTExpDatePicker" formControlName="longTermGapMultiplierPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="longTermGapMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #longTermGapMultiplierPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.longTermGapMultiplierPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('longTermGapMultiplierPCTExpDate').hasError(validation.type) && (form1.get('longTermGapMultiplierPCTExpDate').dirty || form1.get('longTermGapMultiplierPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Long Gap Penalty</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Long Gap Penalty: <b>{{longTermGapPenaltyPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapPenaltyPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
									min="0" max="1" step=".01" pTooltip="Range: 0-1 as decimal. Determines how much of the Long Term Gap Occupancy Target penalty to apply. EXAMPLE: A setting of 0% will apply NONE of the Long Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Long Term Gap Occupancy Target penalty.
							If 12 nights desired but only 8 nights rented, a setting of xx% will apply only to the 4 night penalty."
 tooltipPosition="bottom">
  <input matSliderThumb #longTermGapPenaltyPCT formControlName="longTermGapPenaltyPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapPenaltyPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{longTermGapPenaltyPCTByPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapPenaltyPCTByPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #longTermGapPenaltyPCTByPCT formControlName="longTermGapPenaltyPCTByPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapPenaltyPCTByPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Long Gap Penalty Exp Date</mat-label>
                              <input matInput [matDatepicker]="longTermGapPenaltyPCTExpDatePicker" formControlName="longTermGapPenaltyPCTExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="longTermGapPenaltyPCTExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #longTermGapPenaltyPCTExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.longTermGapPenaltyPCTExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('longTermGapPenaltyPCTExpDate').hasError(validation.type) && (form1.get('longTermGapPenaltyPCTExpDate').dirty || form1.get('longTermGapPenaltyPCTExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>

                        <div class="col-lg-2">
                          <mat-label>Long Gap Empty Occupancy Target</mat-label>
                        </div>
                        <div class="col-lg-2">
                          <mat-label>Long Gap Empty Occupancy Target: <b>{{longTermGapEmptyMultiplierPCT.value*100}}%</b>
                        </mat-label>
                        <div>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyMultiplierPCT', 0.01)">
                            <i class="pi pi-minus"></i>
                          </button>
                          <mat-slider class="flex-1" 
 min="0" max="1" step=".01"
 pTooltip="Range: 0-1 as decimal. EXAMPLE: A setting of 0% means there will be no additional penalty nights assessed if the minNightsExpected is 5 but the gust only books 3. Conversely, a setting of 100% would assess a 2 night penalty if the guest books 3 nights out 5 nights. (longTermGapMultiplierPCT)"
 tooltipPosition="bottom">
  <input matSliderThumb #longTermGapEmptyMultiplierPCT formControlName="longTermGapEmptyMultiplierPCT">
</mat-slider>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyMultiplierPCT', 0.01)">
                            <i class="pi pi-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <mat-label>By PCT: <b>{{longTermGapEmptyMultiplierPCTByPCT.value*100}}%</b></mat-label>
                        <div>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyMultiplierPCTByPCT', 0.01)">
                            <i class="pi pi-minus"></i>
                          </button>
                          <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #longTermGapEmptyMultiplierPCTByPCT formControlName="longTermGapEmptyMultiplierPCTByPCT">
</mat-slider>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyMultiplierPCTByPCT', 0.01)">
                            <i class="pi pi-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        @if (form1.get('updateRateFor').value == 'RT') {
                          <mat-form-field class="w-100">
                            <mat-label>Long Gap Empty Occupancy Target Exp Date</mat-label>
                            <input matInput [matDatepicker]="longTermGapEmptyMultiplierPCTExpDatePicker" formControlName="longTermGapEmptyMultiplierPCTExpDate">
                            <mat-datepicker-toggle matIconSuffix [for]="longTermGapEmptyMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #longTermGapEmptyMultiplierPCTExpDatePicker></mat-datepicker>
                            @for (validation of validationMessages.longTermGapEmptyMultiplierPCTExpDate; track validation) {
                              <mat-error>
                                @if (form1.get('longTermGapEmptyMultiplierPCTExpDate').hasError(validation.type) && (form1.get('longTermGapEmptyMultiplierPCTExpDate').dirty || form1.get('longTermGapEmptyMultiplierPCTExpDate').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.message}}</mat-error>
                                }
                              </mat-error>
                            }
                            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 7)">7</a>&nbsp;
                            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 14)">14</a>&nbsp;
                            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 21)">21</a>&nbsp;
                            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 'N')">N</a>
                          </mat-form-field>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <mat-divider></mat-divider>
                  </div>

                  <div class="col-lg-12 col-md-12">
                    <div class="row">
                      <div class="col-lg-12">
                        <h3>Marketing</h3>
                      </div>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Public Desc</mat-label>
                        <input matInput formControlName="publicRateDesc" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.publicRateDesc; track validation) {
                          <mat-error>
                            @if (form1.get('publicRateDesc').hasError(validation.type) && (form1.get('publicRateDesc').dirty || form1.get('publicRateDesc').touched)) {
                              <mat-error class="error-message"
                                >
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <div class="col-lg-2">
                        <mat-label>Headline Specials Look Forward Days</mat-label>
                      </div>
                      <div class="col-lg-2">
                        <mat-label>Headline Specials Look Forward Days: <b>{{discountLookForwardHeadlineDays.value}}
                        days</b></mat-label>
                        <div>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineDays', 1)">
                            <i class="pi pi-minus"></i>
                          </button>
                          <mat-slider class="flex-1" 
 min="0" max="180" step="1"
 pTooltip="" tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardHeadlineDays formControlName="discountLookForwardHeadlineDays">
</mat-slider>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineDays', 1)">
                            <i class="pi pi-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <mat-label>By PCT: <b>{{discountLookForwardHeadlineDaysByPCT.value*100}}%</b></mat-label>
                        <div>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineDaysByPCT', 0.01)">
                            <i class="pi pi-minus"></i>
                          </button>
                          <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #discountLookForwardHeadlineDaysByPCT formControlName="discountLookForwardHeadlineDaysByPCT">
</mat-slider>
                          <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineDaysByPCT', 0.01)">
                            <i class="pi pi-plus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        @if (form1.get('updateRateFor').value == 'RT') {
                          <mat-form-field class="w-100">
                            <mat-label>Headline Specials Look Forward Days Exp Date</mat-label>
                            <input matInput [matDatepicker]="discountLookForwardHeadlineDaysExpDatePicker" formControlName="discountLookForwardHeadlineDaysExpDate">
                            <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardHeadlineDaysExpDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #discountLookForwardHeadlineDaysExpDatePicker></mat-datepicker>
                            @for (validation of validationMessages.discountLookForwardHeadlineDaysExpDate; track validation) {
                              <mat-error>
                                @if (form1.get('discountLookForwardHeadlineDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardHeadlineDaysExpDate').dirty || form1.get('discountLookForwardHeadlineDaysExpDate').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.message}}</mat-error>
                                }
                              </mat-error>
                            }
                            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 7)">7</a>&nbsp;
                            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 14)">14</a>&nbsp;
                            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 21)">21</a>&nbsp;
                            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 'N')">N</a>
                          </mat-form-field>
                        }
                      </div>

                      <div class="col-lg-2">
                        <mat-label>Headline Specials Min Nights To Analyze</mat-label>
                      </div>
                      <div class="col-lg-2">
                        <mat-label>Headline Specials Min Nights To Analyze:
                          <b>{{discountLookForwardHeadlineMinNightsDays.value}} days</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineMinNightsDays', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" 
 min="0" max="10" step=".01"
 pTooltip="" tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardHeadlineMinNightsDays formControlName="discountLookForwardHeadlineMinNightsDays">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineMinNightsDays', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <mat-label>By PCT: <b>{{discountLookForwardHeadlineMinNightsDaysPCT.value*100}}%</b></mat-label>
                          <div>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('discountLookForwardHeadlineMinNightsDaysPCT', 0.01)">
                              <i class="pi pi-minus"></i>
                            </button>
                            <mat-slider class="flex-1" min="-1" max="1" step=".01">
  <input matSliderThumb #discountLookForwardHeadlineMinNightsDaysPCT formControlName="discountLookForwardHeadlineMinNightsDaysPCT">
</mat-slider>
                            <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('discountLookForwardHeadlineMinNightsDaysPCT', 0.01)">
                              <i class="pi pi-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          @if (form1.get('updateRateFor').value == 'RT') {
                            <mat-form-field class="w-100">
                              <mat-label>Headline Specials Min Nights To Analyze Exp Date</mat-label>
                              <input matInput [matDatepicker]="discountLookForwardHeadlineMinNightsDaysExpDatePicker" formControlName="discountLookForwardHeadlineMinNightsDaysExpDate">
                              <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardHeadlineMinNightsDaysExpDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #discountLookForwardHeadlineMinNightsDaysExpDatePicker></mat-datepicker>
                              @for (validation of validationMessages.discountLookForwardHeadlineMinNightsDaysExpDate; track validation) {
                                <mat-error>
                                  @if (form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').dirty || form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').touched)) {
                                    <mat-error class="error-message">
                                    {{validation.message}}</mat-error>
                                  }
                                </mat-error>
                              }
                              <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 7)">7</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 14)">14</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 21)">21</a>&nbsp;
                              <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 'N')">N</a>
                            </mat-form-field>
                          }
                        </div>
                        @if (form1.get('updateRateFor').value == 'RT') {
                          <div class="col-lg-2">
                            <b><mat-checkbox formControlName="doNotApplyAdjustmentOnRate">DO NOT Apply Time Discount OR Reservation Quality Adjustments</mat-checkbox></b>
                          </div>
                        }

                        <!-- <div class="col-lg-12">
                        <mat-label>Headline Specials Look Forward Days: <b>{{discountLookForwardHeadlineDays.value}}
                        days</b></mat-label>
                        <div>
                          <mat-slider class="flex-1" 
 min="0" max="180" step="1"
 pTooltip="" tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardHeadlineDays formControlName="discountLookForwardHeadlineDays">
</mat-slider>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <mat-label>Headline Specials Min Nights To Analyze:
                          <b>{{discountLookForwardHeadlineMinNightsDays.value}} days</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" 
 min="0" max="10" step=".01"
 pTooltip="" tooltipPosition="bottom">
  <input matSliderThumb #discountLookForwardHeadlineMinNightsDays formControlName="discountLookForwardHeadlineMinNightsDays">
</mat-slider>
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <mat-label>Discount Combination Days: <b>{{discountCombinationDays.value}} days</b></mat-label>
                          <div>
                            <mat-slider class="flex-1" min="0"
 max="30" step=".01"
 pTooltip="Range: 0+ as integer. Documents minimum number of consecutive nights the rate engine should process in a row so it does not just break before a new season rate start."
 tooltipPosition="bottom">
  <input matSliderThumb #discountCombinationDays formControlName="discountCombinationDays">
</mat-slider>
                          </div>
                        </div> -->
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                    </div>

                    <div class="col-lg-12">
                      <mat-divider></mat-divider>
                    </div>

                    <div class="col-lg-6 col-md-6">
                      <div class="row">
                        <div class="col-lg-12">
                          <h2 style="padding-top:50px;">Bulk Update Where Criteria</h2>
                        </div>
                        <div class="col-lg-12">
                          <app-search-template [showSearchButton]="form1.get('updateRateFor').value == 'RT'" reset="true" searchLabel="Process Update" [showLocations]=false
                            [showYieldMaxProperties]=true [showLocations]=true [showDevelopments]=false [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false
                            [showYieldMaxRateBuckets]=true [isBulkEditing]="true" [showSeasons]=true [showStartDate]=true [showEndDate]=true (doChangeCB)="onSearchFormChange($event)" (doSearchCB)="onSearchSubmit($event)"
                            [yieldMaxSelectedProperty] = yieldMaxSelectedProperty [yieldMaxSelectedStartDate] = yieldMaxSelectedStartDate>
                          </app-search-template>
                        </div>
                        <br>
                          <br><br><br><br>
                        </div>
                      </div>

                      @if (form1.get('updateRateFor').value == 'RS') {
                        <div class="col-lg-12">
                          <app-rateSeason-list [isBulkEditing]="true" [updateSeasonList]="updateSeasonList" [reportSearchApi]="form1.get('reportSearchApi')"
                          (doBulkUpdateCB)="onSearchSubmit($event)"></app-rateSeason-list>
                        </div>
                      }

                      <div class="col-lg-12" style="padding-bottom:50px;">
                        <br>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-dialog-content>
                <mat-dialog-actions>
                  <div class="row">
                    <div class="col-lg-12" style="padding-top:20px;">
                      <button style="float:left;" mat-raised-button (click)="resetForm()">Reset Form</button>
                    </div>
                    <div class="col-lg-12" style="padding-top:20px;">
                      <br>
                      </div>
                    </div>
                  </mat-dialog-actions>